// extracted by mini-css-extract-plugin
export default {"wrap":"VJ-z","fullWidth":"WJ-z","hideOnDesktop":"XJ-z","content":"YJ-z","hasOpenedNav":"ZJ-z","crumbsList":"_J-z","dropdownsWrap":"aK-z"};